import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/rem'
import '@/less/reset.less'
import '@/less/common.less'
import Toast from '@/v2-components/toast/index'
import { installClickHandler } from '@/utils/clickHandler'

import * as Sentry from '@sentry/browser'
import { Vue as VueIntegrations } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import hitvCallApp from '@hitv/callapp'

Vue.config.productionTip = false
Vue.use(Toast)
Vue.use(hitvCallApp)
installClickHandler(Vue)

if (process.env.NODE_ENV === 'production') {
  var rate = location.href.indexOf('mgdebug') >= 0 ? 1 : 0.0001
  Sentry.init({
    dsn: "https://63687c3275ee4bce8f18a9e7067c84e0@sentry.log.mgtv.com/43",
    integrations: [
      new VueIntegrations({ Vue, attachProps: true }),
      new Integrations.BrowserTracing({
        tracingOrigins: ['localhost'],
      }),
    ],
    sampleRate: rate,
    tracesSampleRate: rate,
  });
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')